import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import hidden from './hidden.js'
import text from './text.js'
import select from './select.js'
import wrapper from './wrapper.js'

export default contract({
  hidden: array([
    hidden
  ]),
  text: array([
    text
  ]),
  select: array([
    select
  ]),
  wrapper: array([
    wrapper
  ])
})